var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 5.924a8.192 8.192 0 0 1-2.357.646 4.113 4.113 0 0 0 1.805-2.27 8.22 8.22 0 0 1-2.606.996 4.104 4.104 0 0 0-6.993 3.743A11.65 11.65 0 0 1 3.392 4.75a4.09 4.09 0 0 0-.555 2.063c0 1.424.724 2.68 1.825 3.415a4.09 4.09 0 0 1-1.859-.513v.052a4.105 4.105 0 0 0 3.292 4.023 4.092 4.092 0 0 1-1.853.07 4.109 4.109 0 0 0 3.833 2.85 8.23 8.23 0 0 1-5.096 1.757c-.33 0-.657-.019-.979-.057a11.614 11.614 0 0 0 6.29 1.843c7.548 0 11.674-6.252 11.674-11.675 0-.177-.004-.355-.011-.53A8.354 8.354 0 0 0 22 5.923z",
    id: "twitter-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#twitter-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.30ab57f25a9aad1f161285cdb1e40ab8.svg";
export { ForwardRef as ReactComponent };